import React, { useState, useEffect } from 'react';
import CariKendaraan2 from './CariKendaraan2';
import CariMekanik from './CariMekanik';
import CariSopir from './CariSopir';

function InputPpo({ onCancel, onSave, editMode, pasang, title }) {
  const [tglTransaksi, setTglTransaksi] = useState('');
  const [noTransaksi, setNoTransaksi] = useState('');
  const [kd_kendaraan, setKd_kendaraan] = useState('');
  const [nopol, setNopol] = useState('');
  const [sopir, setSopir] = useState('');
  const [mekanik, setMekanik] = useState('');
  const [backup, setBackup] = useState('');
  const [targetSelesai, setTargetSelesai] = useState('');
  const [keterangan, setKeterangan] = useState('');
  const [status, setStatus] = useState('');
  const [detailBarang, setDetailBarang] = useState([]);
  const [idUser, setIdUser] = useState('');
  const [canUnvalid, setCanUnvalid] = useState(true);
  const [showKendaraanLookup, setShowKendaraanLookup] = useState(false);
  const [showSopirLookup, setShowSopirLookup] = useState(false);
  const [showMekanikLookup, setShowMekanikLookup] = useState(false);
  const [showBackupLookup, setShowBackupLookup] = useState(false);

  const schema = localStorage.getItem('schema');

  const isLocked = ['5', '6', '9'].includes(status);

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0];

    if (editMode && pasang) {
      const { master, details } = pasang;
      setTglTransaksi(formatDateForInput(master.TGL_TRANSAKSI));
      setNoTransaksi(master.NO_TRANSAKSI || '');
      setKd_kendaraan(master.KD_KENDARAAN || '');
      setNopol(master.NOPOL || '');
      setSopir(master.SOPIR || '');
      setMekanik(master.MEKANIK || '');
      setBackup(master.BACKUP || '');
      setTargetSelesai(formatDateForInput(master.TARGET_SELESAI));
      setKeterangan(master.KETERANGAN || '');
      setStatus(master.STATUS || '');

      if (details && Array.isArray(details)) {
        setDetailBarang(
          details.map((d, idx) => ({
            NOMOR: d.NOMOR || idx + 1,
            KETERANGAN: d.KETERANGAN || '',
          }))
        );
      } else {
        setDetailBarang([]);
      }
    } else if (pasang?.isNew) {
      setNoTransaksi(0);
      setTglTransaksi(formattedToday);
      setDetailBarang([]);
    }

    const storedIdUser = localStorage.getItem('id_user') || '';
    setIdUser(storedIdUser);
  }, [editMode, pasang]);

  const handleTambahDetail = () => {
    setDetailBarang((prev) => [
      ...prev,
      { NOMOR: prev.length + 1, KETERANGAN: '' },
    ]);
  };

  const handleHapusDetail = (index) => {
    const updated = detailBarang.filter((_, i) => i !== index);
    const reindexed = updated.map((item, idx) => ({
      ...item,
      NOMOR: idx + 1,
    }));
    setDetailBarang(reindexed);
  };

  const handleUbahKeteranganDetail = (index, value) => {
    const updated = [...detailBarang];
    updated[index] = { ...updated[index], KETERANGAN: value };
    setDetailBarang(updated);
  };

  const handleValidasi = async () => {
    const id = noTransaksi || '0';

    try {
      const formData = new URLSearchParams();
      formData.append('caller', 'ppo');
      formData.append('id', id);
      formData.append('schema', schema);
      formData.append('id_user', idUser);
      formData.append('tgl_transaksi', tglTransaksi);
      formData.append('kd_kendaraan', kd_kendaraan);
      formData.append('nopol', nopol);
      formData.append('sopir', sopir);
      formData.append('mekanik', mekanik);
      formData.append('backup', backup);
      formData.append('target_selesai', targetSelesai);
      formData.append('keterangan', keterangan);
      formData.append('detail', JSON.stringify(detailBarang));

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/ppo.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      const result = await response.json();

      if (result.status !== 'success') {
        alert(`Gagal validasi PPO: ${result.message}`);
        return;
      }

      onSave();
    } catch (err) {
      console.error('Error saat validasi PPO:', err);
      alert('Terjadi kesalahan saat menyimpan PPO dan detail.');
    }
  };

  const handleUnvalid = async () => {
    const id = noTransaksi || '0';

    try {
      const formData = new URLSearchParams();
      formData.append('caller', 'ppo_unvalid');
      formData.append('id', id);
      formData.append('schema', schema);

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/ppo.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      const result = await response.json();

      if (result.status === 'success') {
        setStatus('0');
        alert('PPO berhasil unvalid');
      } else {
        alert(`Gagal unvalid: ${result.message}`);
      }
    } catch (err) {
      console.error('Unvalid error:', err);
      alert('Terjadi kesalahan saat unvalid PPO.');
    }
  };

  const handleDelete = async () => {
    const id = noTransaksi || '0';

    try {
      const formData = new URLSearchParams();
      formData.append('caller', 'ppo_hapus');
      formData.append('id', id);
      formData.append('schema', schema);

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/ppo.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      const result = await response.json();

      if (result.status === 'success') {
        alert('PPO berhasil dihapus');
        onSave();
      } else {
        alert(`Gagal hapus: ${result.message}`);
      }
    } catch (err) {
      console.error('Delete error:', err);
      alert('Terjadi kesalahan saat hapus PPO.');
    }
  };

  const handleSelectKendaraan = (selected) => {
    // CariKendaraan2 mengirim array item terpilih; ambil yang pertama
    const kendaraan = Array.isArray(selected) ? selected[0] : selected;
    if (!kendaraan) {
      setShowKendaraanLookup(false);
      return;
    }
    setKd_kendaraan(kendaraan.KD_KENDARAAN || '');
    setNopol(kendaraan.NOPOL || '');
    if (kendaraan.SOPIR) setSopir(kendaraan.SOPIR);
    setShowKendaraanLookup(false);
  };

  const handleSelectSopir = (sopirItem) => {
    if (sopirItem) {
      setSopir(sopirItem.SOPIR || sopirItem.NAMA || '');
    }
    setShowSopirLookup(false);
  };

  const handleSelectMekanik = (mekanikItem) => {
    if (mekanikItem) {
      setMekanik(mekanikItem.SOPIR || mekanikItem.NAMA || '');
    }
    setShowMekanikLookup(false);
  };

  const handleSelectBackup = (backupItem) => {
    if (backupItem) {
      setBackup(backupItem.SOPIR || backupItem.NAMA || '');
    }
    setShowBackupLookup(false);
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '10px', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
      <h2 style={{ marginBottom: '20px', color: '#4A4A4A' }}>{title}</h2>

      {showKendaraanLookup && (
        <CariKendaraan2
          onSelect={handleSelectKendaraan}
          onCancel={() => setShowKendaraanLookup(false)}
        />
      )}

      {showSopirLookup && (
        <CariSopir
          onSelect={handleSelectSopir}
          onCancel={() => setShowSopirLookup(false)}
        />
      )}

      {showMekanikLookup && (
        <CariMekanik
          onSelect={handleSelectMekanik}
          onCancel={() => setShowMekanikLookup(false)}
        />
      )}

      {showBackupLookup && (
        <CariMekanik
          onSelect={handleSelectBackup}
          onCancel={() => setShowBackupLookup(false)}
        />
      )}

      <div>
        <label><strong>No Transaksi</strong></label>
        <input type="text" readOnly value={noTransaksi}
          style={{ width: '100%', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', marginBottom: 10 }}
        />
      </div>

      <div>
        <label><strong>Tanggal</strong></label>
        <input type="date" value={tglTransaksi} onChange={(e) => setTglTransaksi(e.target.value)}
          disabled={isLocked}
          style={{ width: '100%', padding: '8px', borderRadius: '5px', marginBottom: 10 }}
        />
      </div>

      <div style={{ marginBottom: '10px' }}>
        <label><strong>Kendaraan</strong></label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', alignItems: 'center' }}>
          <input type="text" value={kd_kendaraan} readOnly style={{ width: '100px', padding: '5px', backgroundColor: '#E6E6E6' }} />
          <input type="text" value={nopol} readOnly style={{ flex: 1, padding: '5px', backgroundColor: '#E6E6E6' }} />
          <button onClick={() => setShowKendaraanLookup(true)} disabled={isLocked}
            style={{ padding: '5px 10px', backgroundColor: '#00A2E8', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
            Cari
          </button>
        </div>
      </div>

      <div style={{ marginBottom: '10px' }}>
        <label><strong>Sopir</strong></label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', alignItems: 'center' }}>
          <input type="text" value={sopir} readOnly
            style={{ flex: 1, padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px' }}
          />
          <button onClick={() => setShowSopirLookup(true)} disabled={isLocked}
            style={{ padding: '5px 10px', backgroundColor: '#00A2E8', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
            Cari
          </button>
        </div>
      </div>

      <div style={{ marginBottom: '10px' }}>
        <label><strong>Mekanik</strong></label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', alignItems: 'center' }}>
          <input type="text" value={mekanik} readOnly
            style={{ flex: 1, padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px' }}
          />
          <button onClick={() => setShowMekanikLookup(true)} disabled={isLocked}
            style={{ padding: '5px 10px', backgroundColor: '#00A2E8', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
            Cari
          </button>
        </div>
      </div>

      <div style={{ marginBottom: '10px' }}>
        <label><strong>Backup</strong></label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', alignItems: 'center' }}>
          <input type="text" value={backup} readOnly
            style={{ flex: 1, padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px' }}
          />
          <button onClick={() => setShowBackupLookup(true)} disabled={isLocked}
            style={{ padding: '5px 10px', backgroundColor: '#00A2E8', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
            Cari
          </button>
        </div>
      </div>

      <div style={{ marginBottom: '10px' }}>
        <label><strong>Target Selesai</strong></label>
        <input type="date" value={targetSelesai} onChange={(e) => setTargetSelesai(e.target.value)} disabled={isLocked}
          style={{ width: '100%', padding: '8px', borderRadius: '5px', marginBottom: 10 }}
        />
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label><strong>Keterangan</strong></label>
        <textarea value={keterangan} onChange={(e) => setKeterangan(e.target.value)} rows={3}
          disabled={isLocked}
          style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }} />
      </div>

      <div style={{ marginBottom: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <strong>Detail Pekerjaan</strong>
        <button onClick={handleTambahDetail} disabled={isLocked}
          style={{ padding: '6px 12px', backgroundColor: isLocked ? '#A5D6A7' : '#00A2E8', color: 'white', border: 'none', borderRadius: '5px', cursor: isLocked ? 'not-allowed' : 'pointer' }}>
          + Tambah Detail
        </button>
      </div>

      {detailBarang.length > 0 ? (
        <div style={{ marginBottom: 20, overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead style={{ backgroundColor: '#f0f0f0' }}>
              <tr>
                <th style={{ border: '1px solid #ccc', padding: 8, width: 50 }}>No</th>
                <th style={{ border: '1px solid #ccc', padding: 8 }}>Keterangan</th>
                <th style={{ border: '1px solid #ccc', padding: 8, width: 60 }}>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {detailBarang.map((item, index) => (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={{ border: '1px solid #ccc', padding: 6, textAlign: 'center' }}>{index + 1}</td>
                  <td style={{ border: '1px solid #ccc', padding: 6 }}>
                    <textarea
                      value={item.KETERANGAN}
                      disabled={isLocked}
                      onChange={(e) => handleUbahKeteranganDetail(index, e.target.value)}
                      rows={2}
                      style={{ width: '98%', borderRadius: '4px', border: '1px solid #ccc', padding: '4px', fontSize: 13, resize: 'vertical' }} />
                  </td>
                  <td style={{ border: '1px solid #ccc', padding: 6, textAlign: 'center' }}>
                    <button
                      onClick={() => handleHapusDetail(index)}
                      disabled={isLocked}
                      style={{ backgroundColor: '#e53935', color: 'white', border: 'none', borderRadius: 6, padding: '6px 12px', fontSize: 13,
                        cursor: isLocked ? 'not-allowed' : 'pointer', opacity: isLocked ? 0.6 : 1 }}>
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p style={{ color: '#888' }}>Tidak ada detail.</p>
      )}

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '15px' }}>
        <button onClick={handleUnvalid} disabled={!canUnvalid || ['5', '6'].includes(status)}
          style={{ backgroundColor: !canUnvalid || ['5', '6'].includes(status) ? '#A5D6A7' : 'red', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}>
          Un-valid
        </button>
        <button onClick={handleDelete} disabled={isLocked}
          style={{ backgroundColor: isLocked ? '#A5D6A7' : 'red', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}>
          Delete
        </button>
        <button onClick={onCancel} style={{ backgroundColor: 'blue', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}>
          Batal
        </button>
        <button onClick={handleValidasi} disabled={isLocked}
          style={{ backgroundColor: isLocked ? '#A5D6A7' : 'green', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}>
          Valid
        </button>
      </div>
    </div>
  );
}

export default InputPpo;
